// Contants
import { ROLES } from '@/constants'
// Components
import CardContainer from '@/components/ui/CardContainer'
import CompanyBrandLink from '@/components/elements/company/CompanyBrandLink'
import CompanyBrandRequestForm from '@/components/elements/company/CompanyBrandRequestForm'
import VuetifyToolBar from '@/components/ui/VuetifyToolBar'
// Mixins
import addonsMixin from '@/mixins/addonsMixin'
// Vuex
import { mapGetters } from 'vuex'

export default {
  name: 'CompanyBrand',
  components: {
    CardContainer,
    CompanyBrandLink,
    CompanyBrandRequestForm,
    VuetifyToolBar
  },
  mixins: [addonsMixin],
  computed: {
    ...mapGetters('authentication', ['userData']),
    /**
     * ¿Mostramos el formulario de petición?
     *
     * @return {boolean}
     */
    showRequestForm() {
      return this.userData.role === ROLES.partner_partner.value
    }
  }
}
